import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { AtividadeRef } from '../atividade-ref';
import { isOrigemRetorno } from '../../atividade-origem';


interface Config {
    isOrigemRetorno: boolean;
    isConcluida: boolean;
    isAtrasada: boolean;
    isPendente: boolean;
}

@Component({
    selector: 'sgt-atividade-ref-card-info',
    templateUrl: './atividade-ref-card-info.component.html',
    styleUrls: ['./atividade-ref-card-info.component.less']
})
export class AtividadeRefCardInfoComponent implements OnInit, OnChanges {
    config: Config;
    @Input() atividade: AtividadeRef;
    @Output() openAtividade = new EventEmitter<AtividadeRef>();

    ngOnInit(): void {
        this.createConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'atividade' && !changes[propName].isFirstChange()) {
                this.createConfig();
            }
        }
    }

    private createConfig() {
        this.config = {
            isOrigemRetorno: isOrigemRetorno(this.atividade?.origem),
            isConcluida: this.atividade?.concluida,
            isAtrasada: this.atividade?.atrasada && !this.atividade?.concluida,
            isPendente: !this.atividade?.concluida && !this.atividade?.atrasada
        }
    }
}
